import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiIcon, UiLabel, UiButton } from 'ui-components';
import html2canvas from 'html2canvas';
import { PortalWithState } from 'react-portal';
import classNames from 'classnames';
import { StyledScreenshot, StyledScreenshotPortal } from './Screenshot.styles';

const ScreenshotCMP = ({ onChange }) => {
  const { t } = useTranslation();
  const [src, setSrc] = useState();
  const [saveSection, setSaveSectionVisivle] = useState(true);
  const [isMoving, setIsMoving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const rectangleRef = useRef(null);
  const firstPointRef = useRef(null);
  const allPortalFunction = useRef(null);

  /**
   * خالی کردن تصویر
   */
  const handleClearImage = () => {
    setSrc();
    onChange();
  };

  /**
   * شروع انتخاب اسکرین
   */
  const startScreenshot = () => {
    setIsImageLoaded(false);
    handleClearImage();
    setSaveSectionVisivle(true);
  };

  /**
   * فشردن موس
   */
  const handleMouseDown = (e) => {
    if (loading) return;
    setIsMoving(true);
    const { clientX, clientY } = e;
    rectangleRef.current.style.left = `${clientX}px`;
    rectangleRef.current.style.top = `${clientY}px`;
    rectangleRef.current.style.width = '0px';
    rectangleRef.current.style.height = '0px';
    firstPointRef.current = {
      x: clientX,
      y: clientY,
    };
  };

  /**
   * اعمال پوزیشن بخشی که کاربر انتخاب میکند
   */
  const setPosition = (top, left, width, height) => {
    rectangleRef.current.style.top = `${top}px`;
    rectangleRef.current.style.left = `${left}px`;
    rectangleRef.current.style.width = `${Math.abs(width)}px`;
    rectangleRef.current.style.height = `${Math.abs(height)}px`;
  };

  /**
   * کشیدن موس در حالت فشرده بودن
   */
  const handelMouseMove = (e) => {
    if (loading) return;
    if (isMoving) {
      const { clientX, clientY } = e;
      const left = firstPointRef.current.x;
      const top = firstPointRef.current.y;
      const width = clientX - left;
      const height = clientY - top;

      if (width > 0 && height > 0) {
        // پایین سمت راست
        setPosition(top, left, width, height);
      } else if (width < 0 && height < 0) {
        // بالا سمت چپ
        setPosition(clientY, clientX, width, height);
      } else {
        if (width < 0) {
          // پایین سمت چپ
          setPosition(top, clientX, width, height);
        }
        if (height < 0) {
          // بالا سمت راست
          setPosition(clientY, left, width, height);
        }
      }
    }
  };

  /**
   * رها کردن موس
   */
  const handleMouseUp = () => {
    if (loading) return;
    setIsMoving(false);
    // TODO: بررسی بشه اگر اولی از دومی کوچکتر بود جابه جاب بشه
  };

  /**
   * ساختن تصویر بعد از رها کردن موس
   */
  const generateImage = (callback) => {
    setLoading(true);
    setIsImageLoaded(false);
    html2canvas(document.body, {
      useCORS: true,
      scale: 2,
      width: window.width,
      height: window.height,
      x: 0,
      y: 0,
    }).then(function (canvas) {
      const imgBase64 = canvas.toDataURL('image/png');
      setSrc(imgBase64);
      setLoading(false);
      setIsImageLoaded(true);
      setTimeout(() => {
        if (typeof callback === 'function') callback();
        onChange(imgBase64);
      }, 500);
    });
  };

  /**
   * لغو اسکرین‌شات
   */
  const handleCancelScreenshot = (callback) => {
    handleClearImage();
    setSaveSectionVisivle(false);
    if (typeof callback === 'function') callback();
  };

  /**
   * با لود شدن بخش اسکرین شات، واچر روی دکمه F4 و Escape فعال میشود
   */
  useEffect(() => {
    const handleKeyUp = (e) => {
      if (e.key === 'F4') {
        allPortalFunction.current.openPortal();
        startScreenshot();
      } else if (e.key === 'Escape') {
        allPortalFunction.current.closePortal();
      }
    };
    document.body.addEventListener('keyup', handleKeyUp);
    return () => {
      document.body.removeEventListener('keyup', handleKeyUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledScreenshot className='screenshot-component'>
      <PortalWithState>
        {({ openPortal, closePortal, isOpen, portal }) => {
          allPortalFunction.current = {
            openPortal,
            closePortal,
            isOpen,
            portal,
          };
          return (
            <React.Fragment>
              {!src && (
                <div
                  className='flex justify-end'
                  onClick={() => {
                    openPortal();
                    startScreenshot();
                  }}
                >
                  <UiIcon
                    icon='ri-screenshot-2-line'
                    className='ml-10 pointer'
                    color='#199DA3'
                  />
                  <UiLabel color='#199DA3' pointer>
                    {t('support:addScreenshot')}
                  </UiLabel>
                </div>
              )}
              <div className='screenshot-image'>
                {src && (
                  <>
                    <img
                      className='img'
                      width='100%'
                      src={src}
                      alt='react-screen-capture'
                    />
                    <UiIcon
                      icon='ri-close-line icon'
                      className='ml-10 pointer'
                      color='#199DA3'
                      onClick={handleClearImage}
                    />
                  </>
                )}
              </div>
              {portal(
                // visible && (
                <StyledScreenshotPortal className='screenshot-portal'>
                  {!isImageLoaded && (
                    <>
                      <div
                        className='blur-layout'
                        onMouseDown={handleMouseDown}
                        onMouseMove={handelMouseMove}
                        onMouseUp={handleMouseUp}
                      />
                      <div
                        className='user-selected-section'
                        style={{
                          backgroundColor: 'red',
                          position: 'absolute',
                        }}
                        ref={rectangleRef}
                      />
                    </>
                  )}
                  {!isImageLoaded && saveSection && (
                    // نوار راهنمای روی اسکرین شات
                    <div className='save-section flex' data-html2canvas-ignore>
                      <UiIcon
                        icon='ri-close-line icon'
                        className='ml-16 pointer'
                        color='#0C395A'
                        onClick={() => handleCancelScreenshot(closePortal)}
                      />
                      {t('support:selectProblematicPartOfPage')}
                      <UiButton
                        color={'primary'}
                        className='mr-16'
                        fullWidth
                        disabled={loading}
                        loading={loading}
                        onClick={(event) => generateImage(closePortal, event)}
                      >
                        {t('common:save')}
                      </UiButton>
                    </div>
                  )}
                  <img
                    src={src}
                    className={classNames(
                      'full-screen-img',
                      isImageLoaded && 'close'
                    )}
                  />
                </StyledScreenshotPortal>
              )}
            </React.Fragment>
          );
        }}
      </PortalWithState>
    </StyledScreenshot>
  );
};

ScreenshotCMP.propTypes = {
  onChange: PropTypes.func,
};

export default ScreenshotCMP;
